<template>
  <div class="edit-bundle-route">
    <div class="loadingcontainer container" v-if="isLoading">
      <ContentBlock :loading="isLoading" />
    </div>
    <div class="loaded animated fadeIn" v-if="!isLoading">
     <SubHeader>
        <div slot="tabs">
          <ul>
            <RouterLink
              tag="li"
              :class="{ dot: !detailsValidity }"
              :to="{ name: 'tab-details' }"
            >{{ $t('Details') }}</RouterLink>
            <RouterLink
              tag="li"
              :class="{ dot: !contentsValidity }"
              :to="{ name: 'tab-contents' }"
            >{{ $t('Contents') }}</RouterLink>
            <RouterLink
              tag="li"
              :class="{ dot: !availabilityValidity }"
              :to="{ name: 'tab-availability' }"
            >{{ $t('Availability') }}</RouterLink>
          </ul>
        </div>
      </SubHeader>
      <div class="container">
        <BreadcrumbNav :items="breadcrumb" />
        <RouterView :bundle="bundle" />
      </div>
      <BottomBar :valid="valid" @save="doSave" @cancel="doCancel" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import SubHeader from '@/core/shared/components/SubHeader';
import ContentBlock from '@/core/shared/components/ContentBlock';
import FocusModeMixin from '@/core/shared/misc/FocusModeMixin';
import BottomBar from '@/core/shared/components/BottomBar';
import BreadcrumbNav from '@/core/shared/components/BreadcrumbNav';
import BundleValidator from '../BundleValidator';
import i18n from '@/core/i18n';

import store from '@/core/store';
import router from '@/core/routes';

@Component({
  mixins: [FocusModeMixin],
  components: {
    SubHeader,
    ContentBlock,
    BottomBar,
    BreadcrumbNav,
  },
  props: {
    bundleId: {
      type: String,
      required: true,
    },
  },
  computed: {
    valid: function () { return BundleValidator.valid(this.bundle); },
    detailsValidity: function () { return BundleValidator.detailsValidity(this.bundle); },
    contentsValidity: function () { return BundleValidator.contentsValidity(this.bundle); },
    availabilityValidity: function () { return BundleValidator.availabilityValidity(this.bundle); },
  },
  data: () => {
    return {
      bundle: {},
    };
  },
})
export default class EditBundleRoute extends Vue {
  async created () {
    this.$store.commit('setTitle', 'Edit Bundle');

    this.bundle = await this.$store.dispatch('getBundle', this.bundleId);
    this.$store.commit('setTitle', `Edit Bundle '${this.bundle.title}'`);
  }

  // const { loading: isLoading, subscribeToPromise } = useLoading();

  // (function init () {
  //   const promise = store.dispatch('getBundle', props.bundleId);
  //   subscribeToPromise(promise);
  // })();

  get isLoading () {
    return this.$store.state.admin.isFetchingBundle;
  }

  get breadcrumb () {
    return [
      {
        name: i18n.t('Bundles'),
        routerLink: { name: 'bundles' },
      },
      {
        name: this.bundle.title,
      },
    ];
  };

  doCancel () {
    router.push({ name: 'bundles' });
  }

  async doSave () {
    store.commit('setLoadingOverlay', true);

    store.commit('setFlash', {
      type: 'info',
      message: i18n.t('Saving...'),
    });

    store.commit('bundles/set', {
      path: 'allowWebsocketUpdates',
      value: false,
    });

    // const successMessage = i18n.t('Your bundle was successfully updated.');
    const errorMessage = i18n.t('There was an error updating your bundle, please try again.');
    // const bundleToSave = { id: props.bundleId, ...bundleChanges.value };

    try {
      await store.dispatch('storeBundle', this.bundle);
      setTimeout(() => { store.commit('removeFlash'); }, 2000);
      router.push({ name: 'bundles' });
    } catch (error) {
      store.commit('removeFlash');
      if (error.response.status === 500) {
        store.commit('setFlash', {
          type: 'error',
          message: errorMessage,
        });
      }
    } finally {
      store.commit('setLoadingOverlay', false);
      store.commit('bundles/set', {
        path: 'allowWebsocketUpdates',
        value: true,
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.dot {
  position: relative;

  &::after {
    display: block;
    content: "";
    top: 2rem;
    right: calc(var(--spacingMd) - 1.25rem);
    border-radius: 100%;
    position: absolute;
    width: 0.75rem;
    height: 0.65rem;
    background-color: var(--colorSBRedFlat);
  }
}
</style>

<style lang="postcss">
@import "core/shared/styles";

.loadingcontainer {
  padding-top: var(--spacingMd);
}

.breadcrumb-nav {
  margin-bottom: var(--spacingSm);
}

.update-notification {
  border: 0.1rem solid var(--colorGeyser);
  padding: var(--spacingMd);
  margin-bottom: var(--spacingMd);

  & .f9 {
    margin-bottom: 1.5rem;
    color: var(--colorFjord);
  }

  & ul {
    list-style-type: disc;
    padding-left: var(--spacingMd);
    margin-top: var(--spacingSm);
  }

  & li {
    margin-bottom: var(--spacingSm);
  }

  & i {
    color: var(--colorManatee);
    font-style: italic;
  }
}
</style>
